import { getIbtRegisterRedirectPath } from '@/util/register/getIbtRedirectPath'

export const RegisterRoutePath = Object.freeze({
  ibtRegister: '/ibtRegister',
  ibtVerification: '/ibtRegister/ibtVerification',
})

export default [
  {
    path: RegisterRoutePath.ibtRegister,
    name: 'ibtRegister',
    component: () => import('@/views/register/ibtVerification/BankWireTransfer.vue'),
    beforeEnter: async (to, from, next) => {
      const redirectPath = await getIbtRegisterRedirectPath()
      if (redirectPath?.length > 0) {
        next(redirectPath)
      } else {
        next()
      }
    },
  },
  {
    path: RegisterRoutePath.ibtVerification,
    name: 'ibtVerification',
    component: () => import('@/views/register/ibtVerification/IbtVerification.vue'),
    beforeEnter: async (to, from, next) => {
      const redirectPath = await getIbtRegisterRedirectPath()

      if (redirectPath?.length > 0) {
        next(redirectPath)
      } else {
        next()
      }
    },
  },
]
